import { registerPlugin } from '@capacitor/core';

export interface ApplePayPlugin {
  presentApplePay(options: { totalPrice: string }): Promise<{ token: string }>;
}

export const ApplePay = registerPlugin<ApplePayPlugin>('ApplePay');